module.exports = __webpack_public_path__ + "img/backpage.288be0c2.jpg";